export const tag = 'notFoundPageTemplate';
export const load = async () => {
    const { NotFoundPageTemplateComponent } = await import('./not-found-page-template.component');
    return {
        component: NotFoundPageTemplateComponent,
    };
};
